
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import FileUpload from '../../../Shared/FileUpload.vue';
  import {API_URL} from '@/api/axios.config.api';
  import {Prop, Ref, Watch} from 'vue-property-decorator';
  import {timelineState} from '@/utils/store-acessor';

  @Component({
    components: {
      FileUpload
    }
  })
  export default class TimeLineFile extends Vue {

    @Prop({required: true}) challengeId!: number;
    @Prop({required: true}) timelineId!: number;
    @Prop({required: false}) modelId!: number;
    @Prop({required: true}) isActive!: boolean;
    @Ref() readonly fileUpload!: FileUpload;
    file: File | null = null;
    uploading = false;
    snackbarVisibility = false;
    snackbarColor: 'green' | 'red' = 'green';
    snackbarMessage: string = '';

    get url(): string {
      return `${API_URL}v1/contestants/challenges/${this.challengeId}/timelines/${this.timelineId}/interactions`
    }

    get editUrl(): string {
      return `${this.url}/${this.modelId}`
    }

    @Watch('file', {deep: true, immediate: true})
    onFileChange(file: any) {
      if (!!file) {
        this.sendMultipart(!!this.modelId)
      }
    }

    sendMultipart(updating: boolean = false) {
      const credentials = localStorage.getItem('credentials');
      if (!credentials) {
        return;
      }
      this.uploading = true
      const formData = new FormData();
      // @ts-ignore
      formData.append('file', this.file);
      let url = this.url;
      if (updating) {
        formData.append('_method', 'PUT');
        url = this.editUrl;
      }

      const xhr = new XMLHttpRequest();

      xhr.open('POST', url);
      const {token_type: type, access_token: token} = JSON.parse(credentials);
      xhr.setRequestHeader('Authorization', `${type} ${token}`);
      xhr.onloadstart = (e) => this.start(e);
      xhr.onloadend = (e) => this.finish(e);
      xhr.onload = (e) => this.success(e, updating);
      xhr.onerror = (err) => this.failed(err, updating);
      xhr.send(formData);
    }

    private onToastMessage(message: string, color: 'green' | 'red') {
      this.snackbarColor = color;
      this.snackbarVisibility = true;
      this.snackbarMessage = message;
    }

    private start(event: any): any {
      return event
    }

    private finish(event: any): any {
      return event
    }

    private failed(err: any, updating: boolean = false) {
      this.onToastMessage('timeline.messages.interaction_registered_error', 'red')
    }

    private async success(e: ProgressEvent, updating: boolean = false) {
      this.uploading = false;
      this.onToastMessage('timeline.messages.interaction_registered', 'green')
      await timelineState.fetchTimeline(this.challengeId);
    }

  }
